const verification_record = {
    not_found: 'Registo de verificação não encontrado.',
    permission_denied: 'Permissão negada, por favor reautentique-se.',
    not_supported_for_google_one_tap: 'Esta API não suporta o Google One Tap.',
};
export default Object.freeze(verification_record);
